import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge only knows Tailwind's default scale names. The custom `text-*`
 * sizes from src/styles/app.css (`text-body-1`, `text-title-2`, ...) must be
 * registered as font sizes, or twMerge mistakes them for colours and a
 * `text-body-2 text-white` pair loses one of the two.
 */
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                {
                    text: [
                        'display',
                        'large-title',
                        'title-1',
                        'title-2',
                        'title-3',
                        'subtitle-1',
                        'subtitle-2',
                        'body-1',
                        'body-2',
                        'caption',
                        'overline',
                    ],
                },
            ],
        },
    },
});

/** shadcn's class combiner: clsx conditionals + tailwind-merge overrides. */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
